import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class MenuItemStylingModel extends CoreStylingModel {
/**
 * Styling button model
 */
buttonStyling: ButtonStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (this.buttonStyling == null) { this.buttonStyling = new ButtonStylingModel(); }
  }
}

function MenuItemStylingModel_tsickle_Closure_declarations() {
/**
 * Styling button model
 * @type {?}
 */
MenuItemStylingModel.prototype.buttonStyling;
}

